<script>
    export default {
        name: "Squared Image",
        props: {
            imageId: {
                type: Number,
                required: true
            },
            imageIndex: {
                type: Number,
                required: true
            },
            imageUrl: {
                type: String,
                required: true,
                default: ''
            },
            imageText: {
                type: String,
                default: ''
            },
            isHeader: {
                type: Boolean,
                required: true,
                default: false
            },
            isSelect: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            prevImage: false
        }),
        methods: {
            setNewHeadImage() {
                this.$emit('update:image', this.imageId)
            }
        },
        mounted() {
            this.$refs.image.style.height = getComputedStyle(this.$refs.image).width

            setTimeout(() => {
                if (this.imageIndex === 0) {
                    let elemMinWidth = document.querySelectorAll('.img-elem')[1]
                    if (elemMinWidth) {
                        this.$refs.image.style.height = getComputedStyle(elemMinWidth).width
                    }
                }
            }, 100)
        },
        updated() {
            if (this.$refs.image.classList.contains('active')) {
                this.prevImage = this.$refs.image
            }
            if (this.prevImage) {
                if (this.prevImage.classList.contains('active')) this.prevImage.style.height = getComputedStyle(this.$refs.image).width
            }
            //if (!this.$refs.image.classList.contains('active')) this.$refs.image.style.height = getComputedStyle(this.$refs.image).width
            //console.log(getComputedStyle(this.$refs.image).width)
        }
    }
</script>

<template>
    <div ref="image" :class="['img', isHeader ? 'active' : '']" @click="setNewHeadImage">
        <img :src="imageUrl" :alt="`${imageText} (Изображение ${imageIndex+1})`">
        <div v-if="isHeader" class="active-line"></div>
        <div :class="['cover', !isHeader && isSelect ? 'active' : '']"></div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
div.img {
        display: block;
        border: 1px solid $gray;
        box-sizing: border-box;
        background-size: cover !important;
        background-position: center !important;
        position: relative;
        transition: $transition;
        overflow: hidden;
    }

    div.img.active {
        border: 1px solid $gray
    }

    .img img {
        width: 100%;
        height: auto;
        font-size: 12px;
    }

    div.img .cover {
        position: absolute;
        transition: $transition;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(109, 111, 113, 0.0);
    }

    div.img .cover.active {
        background-color: rgba(109, 111, 113, 0.2);
    }

    .active-line {
        position: absolute;
        bottom: -1px;
        width: 100%;
        height: 4px;
        background: $gray;
        z-index: 2;
    }

    @media screen and (max-width: 750px) {
        .active-line {
            height: 3px;
        }
    }
</style>
